module.exports = __webpack_public_path__ + "static/media/acl_meniscus.4ef5d6fa.svg";